/**
 * Country rules: things that belong to a country rather than to one destination id (Greece's 12-guest yacht
 * cap, Croatia's cost copy, flags). Festival destinations sit in the same countries as Croatia and Greece
 * Original, so keying on the country keeps their weeks behaving like they did inside those destinations.
 *
 * Kept free of imports so any helper can use it without an import cycle.
 */
export const COUNTRY = {
  CROATIA: 'HR',
  GREECE: 'GR',
};

const ISO2 = /^[A-Za-z]{2}$/;

/**
 * ISO 3166-1 alpha-2 country of a destination or week, whichever payload it came from:
 * yacht weeks (/api/yl/slim) carry `destinationCountryCode`, destination-tree destinations `countryCode`,
 * JMS-serialized destinations (booking pages) a two-letter `country`, and weeks their `destination`.
 *
 * @param {object|number|string|null|undefined} source destination or week; a bare id has no country
 * @returns {string|null}
 */
export const getCountryCode = source => {
  if (!source || typeof source !== 'object') {
    return null;
  }
  const code = source.destinationCountryCode
    || source.countryCode
    || (typeof source.country === 'string' && ISO2.test(source.country) ? source.country : null);
  if (code) {
    return String(code).toUpperCase();
  }
  if (source.destination && typeof source.destination === 'object') {
    return getCountryCode(source.destination);
  }
  return null;
};

export const isInCountry = (source, countryCode) => getCountryCode(source) === countryCode;
